/*eslint-disable*/
export default {
    data() {
        return {
            defaultCombiningDigitCapacities: [1, 2, 3, 4, 5],
            combiningDigitCapacityLabels: {
                1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                5: this.$i18n.t('common.common_gameSetting_digitCapacity5')
            },
            difficultKeys: {
                'Однозначные цифры': 1,
                'Двузначные цифры': 2,
                'Трехзначные цифры': 3,
                'Четырехзначные цифры': 4,
                'Пятизначные цифры': 5
            }
        }
    },
    computed: {
        filteredCombiningDigitCapacities() {
            return this.defaultCombiningDigitCapacities.filter(
                capacity => capacity <= this.capacitiesLength
            );
        },
        capacitiesLength() {
            return typeof this.selectedGame.parameters.difficult === 'number' ? this.selectedGame.parameters.difficult : this.difficultKeys[this.selectedGame.parameters.difficult];
        }
    },
    methods: {
        changeCombiningDigitCapacities(combiningDigitCapacity) {
            if (this.selectedGame.parameters.combiningDigitCapacities.includes(combiningDigitCapacity)) {
                this.removeCombiningDigitCapacity(combiningDigitCapacity);
            } else {
                this.addCombiningDigitCapacity(combiningDigitCapacity);
            }
        },
        addCombiningDigitCapacity(combiningDigitCapacity) {
            this.selectedGame.parameters.combiningDigitCapacities.push(combiningDigitCapacity);
        },
        removeCombiningDigitCapacity(combiningDigitCapacity) {
            this.selectedGame.parameters.combiningDigitCapacities.splice(
                this.selectedGame.parameters.combiningDigitCapacities.indexOf(combiningDigitCapacity), 1);
        },
        fillCombiningDigitCapacities() {
            let combiningDigitCapacities = [
                ...Array(this.capacitiesLength + 1).keys()
            ];
            combiningDigitCapacities.shift();
            this.selectedGame.parameters.combiningDigitCapacities = combiningDigitCapacities;
        }
    }
}